import * as React from 'react';

interface Props {
  category:string;
  label?:string;
  selectedCategory:string;
  onClick:(category:string)=>void;
}

export const CategoryFilter = (props:Props) => {
  const onClick = () => {
    props.onClick(props.category);
  }
  const uniqueId = props.category.replace(/[^a-zA-Z0-9]/i, "_");
  return (
    <div>
      <input
        type={"radio"}
        name={uniqueId}
        checked={props.category===props.selectedCategory}
        onClick={onClick}
      />
      <label htmlFor={uniqueId} onClick={onClick} >{props.label?props.label:props.category}</label>
    </div>
  );
}
